import React, { useState } from 'react';
import { addProducerBankAccount } from '../../utils/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';

const AddProducerBankDetailsModal = ({ showModal, closeModal, producerData }) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const { id } = useParams();

  const [bankAccountData, setbankAccountData] = useState({
    producer_id: producerData?.id,
    bank_account_name: '',
    bank_account_number: '',
    bank_address: '',
    bank_name: '',
    iban_code: '',
    swift_code: '',
    branch_code: '',
    status: "active",
  });

  const validateInputs = (data) => {
    const errors = {};

    if (!data.bank_account_name) {
      errors.bank_account_name = 'Please enter bank account name';
    }

    if (!data.bank_name) {
      errors.bank_name = 'Please enter bank name';
    }

    if (!data.bank_account_number) {
      errors.bank_account_number = 'Please enter account number';
    }

    if (!data.bank_address) {
      errors.bank_address = 'Please enter bank physical address';
    }

    if (!data.swift_code) {
      errors.swift_code = 'Please enter bank swift code';
    }

    if (!data.branch_code) {
      errors.branch_code = 'Please enter bank Branch code';
    }

    return errors;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setbankAccountData((prevData) => ({ ...prevData, [name]: value }));
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate inputs;
    const inputErrors = validateInputs(bankAccountData);
    if (Object.keys(inputErrors).length > 0) {
      setErrors(inputErrors);
      return;
    }

    try {
      setLoading(true);
      await dispatch(addProducerBankAccount(bankAccountData));
      setLoading(false);
      closeModal();
      window.location.reload();
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        setErrors(error.response.data.errors);
      } else {
        console.error(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showModal ? (
        <div className='fixed inset-0 flex items-center justify-center z-50 overflow-y-auto'>
          <div className='fixed inset-0 bg-black opacity-50'></div>
          <div className='relative p-8 bg-white rounded-lg shadow dark:bg-gray-800 md:p-8 max-h-screen overflow-y-auto'>
            <div class='flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600'>
              <h3 class='text-lg font-semibold text-gray-900 dark:text-white'>
                Add {producerData.contact_name}'s Bank Account
              </h3>
              <button
                type='button'
                onClick={() => closeModal()}
                class='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white'
                data-modal-toggle='updateProductModal'
              >
                <svg
                  aria-hidden='true'
                  class='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clip-rule='evenodd'
                  ></path>
                </svg>
                <span class='sr-only'>Close</span>
              </button>
            </div>

            <form
              className='space-y-4 md:space-y-6'
              onSubmit={handleSubmit}
            >
              <ol className='items-center w-full sm:w-auto space-y-4 sm:flex sm:space-x-8 sm:space-y-0'>
                <li className='flex items-center text-green-600 dark:text-green-500 space-x-2.5'>
                  <span className='flex items-center justify-center w-8 h-8 border border-green-600 rounded-full shrink-0 dark:border-green-500'>
                    1
                  </span>
                  <span>
                    <h4 className='font-medium leading-tight'>
                      Add Bank Details
                    </h4>
                    <p className='text-sm'></p>
                  </span>
                </li>
              </ol>

              <div className="grid gap-6 mb-8 lg:grid-cols-3 p-6 sm:p-16 lg:p-8">

                <div>
                  <label htmlFor="bank_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Select Bank
                  </label>
                  <select
                    name="bank_name"
                    // value={entityData.type}
                    value={bankAccountData.bank_name}
                    onChange={handleInputChange}
                    // onChange={handleInputChange}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                  >
                    <option value="">Choose a Bank</option>
                    <option value="access_bank_zambia">Access Bank Zambia</option>
                    <option value="atlas_mara_bank">Atlas Mara Bank</option>
                    <option value="bank_of_china_zambia">Bank of China (Zambia)</option>
                    <option value="absa_bank_zambia">Absa Bank Zambia</option>
                    <option value="citibank_zambia">Citibank Zambia</option>
                    <option value="ecobank_zambia">Ecobank Zambia</option>
                    <option value="first_alliance_bank_zambia">First Alliance Bank Zambia</option>
                    <option value="first_capital_bank_zambia">First Capital Bank Zambia</option>
                    <option value="first_national_bank_zambia">First National Bank Zambia</option>
                    <option value="indo_zambia_bank">Indo-Zambia Bank</option>
                    <option value="investrust_bank">Investrust Bank</option>
                    <option value="stanbic_bank_zambia">Stanbic Bank Zambia</option>
                    <option value="standard_chartered_bank">Standard Chartered Bank</option>
                    <option value="united_bank_for_africa_zambia">United Bank for Africa Zambia</option>
                    <option value="zambia_industrial_commercial_bank">Zambia Industrial Commercial Bank</option>
                    <option value="zambia_national_commercial_bank">Zambia National Commercial Bank</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="bank_account_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Bank Account Name
                  </label>
                  <input
                    iban_code="text"
                    name="bank_account_name"
                    value={bankAccountData.bank_account_name}
                    onChange={handleInputChange}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                  />
                  {errors.bank_account_name && <p className="text-red-500 text-xs mt-1">{errors.bank_account_name}</p>}
                </div>
                <div>
                  <label htmlFor="bank_account_number" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Bank Account Number
                  </label>
                  <input
                    iban_code="number"
                    name="bank_account_number"
                    value={bankAccountData.bank_account_number}
                    onChange={handleInputChange}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                  />
                  {errors.bank_account_number && <p className="text-red-500 text-xs mt-1">{errors.bank_account_number}</p>}
                </div>

                <div>
                  <label htmlFor="bank_account_number" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Bank Branch Name & Address
                  </label>
                  <input
                    iban_code="text"
                    name="bank_address"
                    value={bankAccountData.bank_address}
                    onChange={handleInputChange}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                  />
                  {errors.bank_address && <p className="text-red-500 text-xs mt-1">{errors.bank_address}</p>}
                </div>

                <div>
                  <label htmlFor="branch_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Bank Branch Code
                  </label>
                  <input
                    iban_code="text"
                    name="branch_code"
                    value={bankAccountData.branch_code}
                    onChange={handleInputChange}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                  />
                  {errors.branch_code && <p className="text-red-500 text-xs mt-1">{errors.branch_code}</p>}
                </div>
                <div>
                  <label htmlFor="swift_code" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Bank SWIFT Code
                  </label>
                  <input
                    iban_code="text"
                    name="swift_code"
                    value={bankAccountData.swift_code}
                    onChange={handleInputChange}
                    required
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500"
                  />
                  {errors.swift_code && <p className="text-red-500 text-xs mt-1">{errors.swift_code}</p>}
                </div>
              </div>

              <div className='flex space-x-4'>
                <button
                  type='button'
                  onClick={closeModal}
                  className='text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2'
                >
                  Close
                </button>
                <button
                  type='submit'
                  className='text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-primary-800 mr-2 mb-2'
                >
                  {loading
                    ? 'Adding Bank Details...'
                    : 'Add Bank Details'}
                </button>
              </div>
              {error && (
                <div
                  className='p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400'
                  role='alert'
                >
                  <span className='font-medium'>Error: </span>
                  {error}
                </div>
              )}
              {loading && (
                <div className='text-center'>
                  <div role='status'>
                    <svg
                      aria-hidden='true'
                      className='inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600'
                      viewBox='0 0 100 101'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                        fill='currentColor'
                      />
                      <path
                        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                        fill='currentFill'
                      />
                    </svg>
                    <span className='sr-only'>Please wait...</span>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AddProducerBankDetailsModal;
